export enum TripPaymentStatus_Enum {
  waitingToPay,
  Paid,
  NotEnoughMoney,
}
export enum TransactionType_Enum {
  driverCharge,
  tripRequest,
}
export enum NotifyType_Enum {
  optional = 1,
  forced = 2,
  operational = 3,
  operationalModal = 4,
}

export enum Systems_Enum {
  core = 1,
  attendance = 10,
  buffet = 12,
  pishgamanTransport = 33,
  pishgamanServices = 34,
  pishgamanConference = 35,
  pishgamanTicket = 36,
}
export enum SurveyStatus_Enum {
  Completed = 1,
  UnSeen = 2,
  Rejected = 3,
}

//#region GetCallSaleStatus
export enum GetCallSaleStatus_Enum {
  Registered = 1,
  InStation = 2,
  InMission = 3,
  EndMission = 4,
  Cancel = 5,
  GetToSource = 6,
  AcceptTrip = 7,
  AcceptReserve = 8,
  MoveToPassenger = 9,
  EnterToThePassengerPool = 10,
  AutoSearchForDriver = 11,
  FinalAcceptTrip = 12,
  PendingToPassengerPool = 13,
  Accepted = 14,
  PendingToPayPrePayment = 15,
}

export const GetCallSaleStatus_Display: { [index: number]: string } = {
  [GetCallSaleStatus_Enum.Registered]: "ثبت شده",
  [GetCallSaleStatus_Enum.InStation]: "در سکو",
  [GetCallSaleStatus_Enum.InMission]: "در حال سرویس",
  [GetCallSaleStatus_Enum.EndMission]: "پایان سرویس",
  [GetCallSaleStatus_Enum.Cancel]: "لغو",
  [GetCallSaleStatus_Enum.GetToSource]: "به مبدا رسیدم",
  [GetCallSaleStatus_Enum.AcceptTrip]: "تایید راننده » قبول سفر",
  [GetCallSaleStatus_Enum.AcceptReserve]: "تایید راننده » رزرو اولیه",
  [GetCallSaleStatus_Enum.MoveToPassenger]: "حرکت به سمت مسافر",
  [GetCallSaleStatus_Enum.EnterToThePassengerPool]: "درج سالن مسافر",
  [GetCallSaleStatus_Enum.AutoSearchForDriver]: "جستجو راننده",
  [GetCallSaleStatus_Enum.FinalAcceptTrip]: "تایید راننده » رزرو نهایی",
  [GetCallSaleStatus_Enum.PendingToPassengerPool]:
    "درانتظار ورود به سالن مسافر",
  [GetCallSaleStatus_Enum.Accepted]: "تایید راننده",
  [GetCallSaleStatus_Enum.PendingToPayPrePayment]: "در انتظار پرداخت بیعانه",
};

//#endregion

// #region CardVerificationStatus
export enum CardVerificationStatus_Enum {
  Pending = 0,
  Confirm = 1,
  // عدم تایید
  Rejected = 2,
}

export const CardVerificationStatus_Display: { [index: number]: string } = {
  [CardVerificationStatus_Enum.Pending]: "در حال بررسی",
  [CardVerificationStatus_Enum.Confirm]: "تایید شده",
  [CardVerificationStatus_Enum.Rejected]: "رد شده ",
};
// #endregion

// #region WithdrawalRequestStatus
export enum WithdrawalRequestStatus_Enum {
  pending = 1,
  canceled = 2,
  approve = 3,
  rejected = 4,
  paid = 5,
}

export const WithdrawalRequestStatus_Display: { [index: number]: string } = {
  [WithdrawalRequestStatus_Enum.pending]: "در انتظار تایید",
  [WithdrawalRequestStatus_Enum.canceled]: "لغو شده",
  [WithdrawalRequestStatus_Enum.approve]: "تایید شده",
  [WithdrawalRequestStatus_Enum.rejected]: "عدم تایید",
  [WithdrawalRequestStatus_Enum.paid]: "پرداخت شده",
};
// #endregion
